import Vue from 'vue';
import { mapActions } from 'vuex';
import { SnackBarType } from '@/store/modules/snackbar';

import { sync } from 'vuex-pathify';

export default Vue.extend({
  name: 'snackbar-callable',
  computed: {
    snack: sync<boolean>('snackbar/value'),
    snackbar: sync<SnackBarType>('snackbar/snackbar'),

    computedIcon(): string {
      if (this.snackbar.icon) {
        return this.snackbar.icon;
      }
      switch (this.snackbar.type) {
        case 'edit':
          return 'mdi-content-save';
        case 'delete':
          return 'mdi-delete';
        case 'primary':
          return 'mdi-account-circle';
        case 'store':
          return 'mdi-cart';
        case 'success':
          return 'mdi-check';
        case 'info':
          return 'mdi-information';
        case 'warning':
          return 'mdi-alert';
        case 'error':
          return 'mdi-alert-circle';
        case 'download':
          return 'mdi-download';
        default:
          return 'mdi-account-circle';
      }
    }
  },
  methods: {
    ...mapActions({
      /**
       * @public
       * creates snackbar callee
       * @param {SnackBarType} snackbar
       */
      createSnack: 'snackbar/createSnack'
    })
  }
});
